import navbarSearch from '../modules/navbar-search';
import {initializeAdmin} from '../modules/admin/hamburger';
import socialAnalytics from '../utils/social_analytics_util';
import welcomeAd from '../modules/welcome-ad';
import $ from 'jquery';

let commonController = () => {
    // require('../modules/adblock').on();
    require('../modules/hamburger').on();
    require('../modules/hamburger-sections')();
    // require('../modules/randomize-ab-nav')();
    welcomeAd();
    navbarSearch.on();
    initializeAdmin();
    socialAnalytics();
    require('../../../../../node_modules/lazyloadxt/dist/jquery.lazyloadxt');
    require('../../../../../node_modules/lazyloadxt/dist/jquery.lazyloadxt.video');
    require('../../../../../node_modules/lazyloadxt/dist/jquery.lazyloadxt.srcset');
    $.extend($.lazyLoadXT, {
        edgeY: 200,
        edgeX: 400,
        selector: 'img[data-src],video:not(.jw-video),iframe[data-src],img[data-srcset]'
    });
};

export default commonController;
